<div [attr.section-name]="sectionName"
  appIntersectionObserver
  (visibilityChange)="onVisibilityChanged($event)">
  <h3>Other Information</h3>

  <section>
    <app-editable-textual-input [fieldId]="'primaryPhone'"
      [iconName]="'call'"
      [isFieldWithDataSource]="isFieldWithDataSource('primaryPhone')"
      [hasActiveConnection]="hasActiveConnection('primaryPhone') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'additionalPhone'"
      [subtype]="'multiline_text'"
      [isFieldWithDataSource]="isFieldWithDataSource('additionalPhone')"
      [hasActiveConnection]="hasActiveConnection('additionalPhone') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'primaryCategory'"
      [iconName]="'category_outline'"
      [isFieldWithDataSource]="isFieldWithDataSource('primaryCategory')"
      [hasActiveConnection]="hasActiveConnection('primaryCategory') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'additionalCategory'"
      [subtype]="'multiline_text'"
      [isFieldWithDataSource]="isFieldWithDataSource('additionalCategory')"
      [hasActiveConnection]="hasActiveConnection('additionalCategory') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'fromTheBusiness'"
      [subtype]="'multiline_text'"
      [iconName]="'notes'"
      [isFieldWithDataSource]="isFieldWithDataSource('fromTheBusiness')"
      [hasActiveConnection]="hasActiveConnection('fromTheBusiness') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'menuURL'"
      [iconName]="'link'"
      [subtype]="'link'"
      [isFieldWithDataSource]="isFieldWithDataSource('menuURL')"
      [hasActiveConnection]="hasActiveConnection('menuURL') | ngrxPush"
    ></app-editable-textual-input>

    <!--                                    social media links                                   -->

    <app-editable-textual-input [fieldId]="socialMediaUrl.FACEBOOK"
      [formGroupNameRef]="'socialMediaUrls'"
      [subtype]="'link'"
      [isFieldWithDataSource]="isFieldWithDataSource('socialMediaUrls')"
      [hasActiveConnection]="hasActiveConnection('socialMediaUrls') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="socialMediaUrl.INSTAGRAM"
      [formGroupNameRef]="'socialMediaUrls'"
      [subtype]="'link'"
      [isFieldWithDataSource]="isFieldWithDataSource('socialMediaUrls')"
      [hasActiveConnection]="hasActiveConnection('socialMediaUrls') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="socialMediaUrl.LINKEDIN"
      [formGroupNameRef]="'socialMediaUrls'"
      [subtype]="'link'"
      [isFieldWithDataSource]="isFieldWithDataSource('socialMediaUrls')"
      [hasActiveConnection]="hasActiveConnection('socialMediaUrls') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="socialMediaUrl.PINTEREST"
      [formGroupNameRef]="'socialMediaUrls'"
      [subtype]="'link'"
      [isFieldWithDataSource]="isFieldWithDataSource('socialMediaUrls')"
      [hasActiveConnection]="hasActiveConnection('socialMediaUrls') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="socialMediaUrl.TIKTOK"
      [formGroupNameRef]="'socialMediaUrls'"
      [subtype]="'link'"
      [isFieldWithDataSource]="isFieldWithDataSource('socialMediaUrls')"
      [hasActiveConnection]="hasActiveConnection('socialMediaUrls') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="socialMediaUrl.TWITTER"
      [formGroupNameRef]="'socialMediaUrls'"
      [subtype]="'link'"
      [isFieldWithDataSource]="isFieldWithDataSource('socialMediaUrls')"
      [hasActiveConnection]="hasActiveConnection('socialMediaUrls') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="socialMediaUrl.YOUTUBE"
      [formGroupNameRef]="'socialMediaUrls'"
      [subtype]="'link'"
      [isFieldWithDataSource]="isFieldWithDataSource('socialMediaUrls')"
      [hasActiveConnection]="hasActiveConnection('socialMediaUrls') | ngrxPush"
    ></app-editable-textual-input>


    <app-editable-textual-input [fieldId]="'appointmentURL'"
      [subtype]="'multiline_text'"
      [isFieldWithDataSource]="isFieldWithDataSource('appointmentURL')"
      [hasActiveConnection]="hasActiveConnection('appointmentURL') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'orderAheadURL'"
      [subtype]="'multiline_text'"
      [isFieldWithDataSource]="isFieldWithDataSource('orderAheadURL')"
      [hasActiveConnection]="hasActiveConnection('orderAheadURL') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'reservationsURL'"
      [subtype]="'multiline_text'"
      [isFieldWithDataSource]="isFieldWithDataSource('reservationsURL')"
      [hasActiveConnection]="hasActiveConnection('reservationsURL') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'labels'"
      [iconName]="'label_outline'"
      [isFieldWithDataSource]="isFieldWithDataSource('labels')"
      [hasActiveConnection]="hasActiveConnection('labels') | ngrxPush"
    ></app-editable-textual-input>

    <!-- == Google Ads Phone -->
    <app-editable-textual-input [fieldId]="'adwordsLocation'"
      [isFieldWithDataSource]="isFieldWithDataSource('adwordsLocation')"
      [hasActiveConnection]="hasActiveConnection('adwordsLocation') | ngrxPush"
    ></app-editable-textual-input>

    <!-- CUSTOM SERVICES AND STATUS -->

    @for (nonStandardInput of nonStandardInputsKeys; track nonStandardInput; let i = $index) {
      <div
        (mouseenter)="nonStandardInputs[nonStandardInput]['dataScrIconVisible'] = true"
        (mouseleave)="nonStandardInputs[nonStandardInput]['dataScrIconVisible'] = false">
        <div class="pb-3 pt-5 flex flex-row items-center">
          <mat-icon class="text-green-10 mr-4 nonStandardInputIcon"
          [svgIcon]="nonStandardInputs[nonStandardInput]['icon']"></mat-icon>
          <span class="text-neutral-10 text-title-small
                     w-full">{{ getFieldName(nonStandardInput) }}</span>
        <div [ngStyle]="{
          'visibility': nonStandardInputs[nonStandardInput]['dataScrIconVisible'] ? 'visible' : 'hidden'
       }">
            @if (isFieldWithDataSource(nonStandardInput)) {
              <mat-icon
                [ngClass]="hasActiveConnection(nonStandardInput) ? 'active' : 'inactive'"
                [svgIcon]="hasActiveConnection(nonStandardInput) ? 'fiber_manual_record' : 'fiber_manual_record_outline'"
                class="dataSourceIcon"
                matTooltip="{{ hasActiveConnection(nonStandardInput) ?
                    ('ADDRESS_LIST.DATA_SOURCE_CONFIG.TOOLTIP.ACTIVE' | translate) :
                    ('ADDRESS_LIST.DATA_SOURCE_CONFIG.TOOLTIP.INACTIVE' | translate) }}"
                matTooltipPosition="below">
              </mat-icon>
            }
          </div>
        </div>
        @if (i === 0) {
          <!--Custom Services body-->
          @for (_ of customServicesFormArray.controls; track _; let i = $index) {
            <div
              class="flex flex-col ml-8"
              (mouseenter)="showActionButtons(i)"
              (mouseleave)="formGroupNameWithVisibleButtons = null">
              <app-editable-custom-services-inputs
                #serviceNameInputComponent
                [formGroupNameRef]="i"
                [fieldId]="'serviceName'"
                [formGroupNameWithVisibleButtons]="formGroupNameWithVisibleButtons">
              </app-editable-custom-services-inputs>
              <div class="my-2"></div>
              <app-editable-custom-services-inputs
                [formGroupNameRef]="i"
                [fieldId]="'serviceDescription'"
                [subType]="'multiline_text'">
              </app-editable-custom-services-inputs>
              <div class="my-2"></div>
              <app-editable-custom-services-inputs
                [formGroupNameRef]="i"
                [fieldId]="'serviceCategoryId'"
                [subType]="'text'">
              </app-editable-custom-services-inputs>
              <mat-divider class="mt-6 mb-2"></mat-divider>
            </div>
          }
          <button mat-stroked-button type="button" color="primary"
            (click)="doAddCustomServicePair()"
            class="my-[6px] ml-[40px] mr-4">
            <mat-icon class="addCustomServiceIcon" svgIcon="add_circle_outline"></mat-icon>
            New custom service
          </button>
        } @else {
          <div [formGroup]="getFormGroup()">
            <div id="statusToggles" formGroupName="status">
              <mat-button-toggle-group formControlName="businessStatus">
                <mat-button-toggle value="CLOSED_PERMANENTLY">Permanently closed
                </mat-button-toggle>
                <mat-button-toggle value="CLOSED_TEMPORARILY">Temporarily closed
                </mat-button-toggle>
                <mat-button-toggle value="OPEN">Open</mat-button-toggle>
              </mat-button-toggle-group>
              <mat-button-toggle-group formControlName="managementStatus">
                <mat-button-toggle
                  value="AUTOMATICALLY_MANAGED"
                  [disabled]="getFormGroup()?.get('status')?.get('managementStatus')?.value === 'MANUALLY_MANAGED'">
                  Automatically managed
                </mat-button-toggle>
                <mat-button-toggle
                  value="MANUALLY_MANAGED"
                  [disabled]="getFormGroup()?.get('status')?.get('managementStatus')?.value === 'AUTOMATICALLY_MANAGED'">
                  Manually managed
                </mat-button-toggle>
                <mat-button-toggle
                  value="NOT_MANAGED">Not managed
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
        }
      </div>
    }

  </section>
</div>


